import { paginationEllipseVariants } from './index.styles'

export const PaginationEllipse = () => {
  return <li className={paginationEllipseVariants()}>...</li>
}
